import { FormSectionTermView } from "./FormSectionTerm"

export const SchoolTripOfferView = ({ offer }) => {
  return (
    <div>
      <FormSectionTermView values={offer} />
    </div>
  )
}
